import { gql } from '@apollo/client';

const REJECT_RMA_TICKET_MUTATION = gql`
  mutation rejectRmaTicket($id: ID!) {
    rejectRmaTicket(id: $id) {
      isSuccess
      message
    }
  }
`;

export default REJECT_RMA_TICKET_MUTATION;
